import { find } from 'lodash';
import { createGaActionCreatorWithDetails } from 'src/Booking/utils/createGaActionCreator';
import { BookingStateProperties } from '../../constants';
import bookingStateSelector from '../../selectors/BookingStateSelector';
import { createGaActionCreator } from '../../utils';
import { APPOINTMENT_DETAILS_GA_CATEGORY, GaActionText } from './constants';

const ENTER_INSURANCE_ID = '@@ad/ENTER_INSURANCE_ID';
const TRIM_INSURANCE_ID = '@@ad/TRIM_INSURANCE_ID';
const ENTER_DOCTOR_NOTES = '@@ad/ENTER_DOCTOR_NOTES';
const GETTING_INSURANCE_CARRIER_NAME = '@@ad/GETTING_INSURANCE_CARRIER_NAME';
const GET_INSURANCE_CARRIER_NAME_SUCCESS =
    '@@ad/GET_INSURANCE_CARRIER_NAME_SUCCESS';
const GET_INSURANCE_CARRIER_NAME_FAILURE =
    '@@ad/GET_INSURANCE_CARRIER_NAME_FAILURE';
const GETTING_INSURANCE_PLAN_NAME = '@@ad/GETTING_INSURANCE_PLAN_NAME';
const GET_INSURANCE_PLAN_NAME_SUCCESS = '@@ad/GET_INSURANCE_PLAN_NAME_SUCCESS';
const GET_INSURANCE_PLAN_NAME_FAILURE = '@@ad/GET_INSURANCE_PLAN_NAME_FAILURE';

const TRACK_CLICK_EDIT_PHONE_NUMBER = '@@ad/TRACK_CLICK_EDIT_PHONE_NUMBER';
const TRACK_SELECT_INSURANCE_ID = '@@ad/TRACK_SELECT_INSURANCE_ID';
const TRACK_SELECT_DOCTOR_NOTES = '@@ad/TRACK_SELECT_DOCTOR_NOTES';
const TRACK_CLICK_BOOK_APPOINTMENT = '@@ad/TRACK_CLICK_BOOK_APPOINTMENT';
const TRACK_SHOW_REQUIRED_MEMBER_ID_FIELD =
    '@@ad/TRACK_SHOW_REQUIRED_MEMBER_ID_FIELD';
const TRACK_BOOKING_APPT_CLICKED = '@@ad/TRACK_BOOKING_APPT_CLICKED';
const TRACK_EXPOSED_CONTROLS = '@@ad/TRACK_EXPOSED_CONTROLS';

export const AppointmentDetailsActions = {
    ENTER_INSURANCE_ID,
    TRIM_INSURANCE_ID,
    ENTER_DOCTOR_NOTES,
    GETTING_INSURANCE_CARRIER_NAME,
    GET_INSURANCE_CARRIER_NAME_SUCCESS,
    GET_INSURANCE_CARRIER_NAME_FAILURE,
    GETTING_INSURANCE_PLAN_NAME,
    GET_INSURANCE_PLAN_NAME_SUCCESS,
    GET_INSURANCE_PLAN_NAME_FAILURE,
    TRACK_CLICK_EDIT_PHONE_NUMBER,
    TRACK_EXPOSED_CONTROLS,
    TRACK_SELECT_INSURANCE_ID,
    TRACK_SELECT_DOCTOR_NOTES,
    TRACK_CLICK_BOOK_APPOINTMENT,
    TRACK_BOOKING_APPT_CLICKED,
    TRACK_SHOW_REQUIRED_MEMBER_ID_FIELD,
};

export const enterInsuranceId = (insuranceId, insuranceIdSourceType) => ({
    type: AppointmentDetailsActions.ENTER_INSURANCE_ID,
    insuranceId,
    insuranceIdSourceType,
});

export const trimInsuranceId = () => ({
    type: AppointmentDetailsActions.TRIM_INSURANCE_ID,
});

export const enterDoctorNotes = (doctorNotes) => ({
    type: AppointmentDetailsActions.ENTER_DOCTOR_NOTES,
    doctorNotes,
});

export const gettingInsuranceCarrierName = () => ({
    type: AppointmentDetailsActions.GETTING_INSURANCE_CARRIER_NAME,
});

export const getInsuranceCarrierNameSuccess = (insuranceCarrier) => ({
    type: AppointmentDetailsActions.GET_INSURANCE_CARRIER_NAME_SUCCESS,
    insuranceCarrier,
});

export const getInsuranceCarrierNameFailure = () => ({
    type: AppointmentDetailsActions.GET_INSURANCE_CARRIER_NAME_FAILURE,
});

export const gettingInsurancePlanName = () => ({
    type: AppointmentDetailsActions.GETTING_INSURANCE_PLAN_NAME,
});

export const getInsurancePlanNameSuccess = (insurancePlan) => ({
    type: AppointmentDetailsActions.GET_INSURANCE_PLAN_NAME_SUCCESS,
    insurancePlan,
});

export const getInsurancePlanNameFailure = () => ({
    type: AppointmentDetailsActions.GET_INSURANCE_PLAN_NAME_FAILURE,
});

const apiHost = process.env.API_HOST || '';
const getInsuranceCarrierEndpoint = (carrierId) =>
    `${apiHost}/api/1/carriers/carrier/${carrierId}`;
const getInsurancePlansEndpoint = (carrierId) =>
    `${apiHost}/api/1/carriers/${carrierId}/plans`;

export function getInsuranceCarrierPromise(carrierId) {
    return fetch(getInsuranceCarrierEndpoint(carrierId), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });
}

export const getInsuranceCarrierName = (carrierId) => {
    return (dispatch) => {
        dispatch(gettingInsuranceCarrierName());

        let responseStatus;
        return getInsuranceCarrierPromise(carrierId)
            .then((response) => {
                responseStatus = response.status;
                if (responseStatus === 200) {
                    return response.json().then((body) => {
                        if (body) {
                            dispatch(
                                getInsuranceCarrierNameSuccess(body.carrier[1])
                            );
                        } else {
                            dispatch(getInsuranceCarrierNameFailure());
                        }
                    });
                } else {
                    dispatch(getInsuranceCarrierNameFailure());
                }
            })
            .catch(() => {
                dispatch(getInsuranceCarrierNameFailure());
            });
    };
};

export function getInsurancePlanPromise(carrierId) {
    return fetch(getInsurancePlansEndpoint(carrierId), {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    });
}

export const getInsurancePlanName = (carrierId, planId) => {
    return (dispatch) => {
        dispatch(gettingInsurancePlanName());

        let responseStatus;
        return getInsurancePlanPromise(carrierId)
            .then((response) => {
                responseStatus = response.status;
                if (responseStatus === 200) {
                    return response.json().then((body) => {
                        if (body) {
                            const selectedPlan = find(
                                body.plans,
                                (plan) => plan.id === planId
                            );
                            dispatch(
                                getInsurancePlanNameSuccess(selectedPlan.name)
                            );
                        } else {
                            dispatch(getInsurancePlanNameFailure());
                        }
                    });
                } else {
                    dispatch(getInsurancePlanNameFailure());
                }
            })
            .catch(() => {
                dispatch(getInsurancePlanNameFailure());
            });
    };
};

export const trackClickEditPhoneNumber = () =>
    createGaActionCreator(
        TRACK_CLICK_EDIT_PHONE_NUMBER,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.clickEditPhoneNumber
    );

export const trackSelectInsuranceId = () =>
    createGaActionCreator(
        TRACK_SELECT_INSURANCE_ID,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.selectInsuranceId
    );

export const trackSelectDoctorNotes = () =>
    createGaActionCreator(
        TRACK_SELECT_DOCTOR_NOTES,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.selectDoctorNotes
    );

export const trackClickBookAppointment = (eventDetails) => {
    const baseAction = createGaActionCreatorWithDetails(
        TRACK_CLICK_BOOK_APPOINTMENT,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.clickBookAppointment,
        eventDetails
    );

    if (window.dataLayer) {
        window.dataLayer.push({
            // eslint-disable-next-line
            event: `[${APPOINTMENT_DETAILS_GA_CATEGORY}] ${GaActionText.clickBookAppointment}`,
        });
    }

    return baseAction;
};

export const trackShowRequiredMemberIdField = () =>
    createGaActionCreator(
        TRACK_SHOW_REQUIRED_MEMBER_ID_FIELD,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.trackShowRequiredMemberIdField
    );

export const trackBookingApptClicked = () =>
    createGaActionCreator(
        TRACK_BOOKING_APPT_CLICKED,
        APPOINTMENT_DETAILS_GA_CATEGORY,
        GaActionText.bookingApptClicked
    );

export const trackExposedControls = () => {
    return (dispatch, getState) => {
        // Get initial patient state.
        const state = getState();
        const bookingState = bookingStateSelector(state);
        if (bookingState) {
            const isExistingPatient =
                bookingState[BookingStateProperties.existingPatient];
            const actionText = isExistingPatient
                ? GaActionText.trackExposedControlsExisting
                : GaActionText.trackExposedControlsNew;
            dispatch(
                createGaActionCreator(
                    TRACK_EXPOSED_CONTROLS,
                    APPOINTMENT_DETAILS_GA_CATEGORY,
                    actionText
                )
            );
        }
    };
};

export const AppointmentDetailsActionCreators = {
    trackClickEditPhoneNumber,
    trackSelectInsuranceId,
    trackSelectDoctorNotes,
    trackClickBookAppointment,
    trackBookingApptClicked,
    trackShowRequiredMemberIdField,
};
